import type { CSSProperties } from 'react';
import { Notifications } from '@mantine/notifications';
import { layoutTokens } from '../tokens/layout';
import { zIndex } from '../tokens/zIndex';
import classes from './ToastHost.module.css';

export function ToastHost() {
  return (
    <Notifications
      position="top-right"
      zIndex={zIndex.toast}
      autoClose={10000}
      containerWidth={420}
      classNames={{ root: classes.root }}
      style={{ '--toast-header-offset': `${layoutTokens.headerHeight + 8}px` } as CSSProperties}
    />
  );
}
